import React, { useState } from 'react';
import { Row, Col, Button, Space, Card, Divider, Typography, Checkbox } from 'antd';
import { useWizard } from 'components/shared/Wizard';
import { getTranslatedString } from 'helpers/i18n';
import ApplicationSidebar from 'components/tenant_app/application_portal/application_sidebar/ApplicationSidebar';

const { Title } = Typography;

const ApplicationSubmission = ({
  applicationTemplate,
  cotenant,
  onSubmit,
  onClickSave,
  isPreview,
}) => {
  const [consent, setConsent] = useState(false);
  const { previousStep } = useWizard();

  return (
    <Row gutter={16}>
      <Col className="gutter-row" xs={{ span: 24, order: 0 }} md={{ span: 8, order: 1 }}>
        <ApplicationSidebar applicationWizard cotenantId={cotenant.id} isPreview={isPreview} />
      </Col>

      <Col xs={24} md={0}>
        <Divider />
      </Col>

      <Col className="gutter-row" xs={{ span: 24, order: 1 }} md={{ span: 16, order: 0 }}>
        <Card>
          <Title level={4}>
            {getTranslatedString('tenantPortal.application.submitApplication')}
          </Title>

          <Divider />
          <Space direction="vertical">
            <Title level={4}>{applicationTemplate.confirmation_detail_title}</Title>
            <Checkbox checked={consent} onClick={() => setConsent(!consent)}>
              {applicationTemplate.confirmation_detail_description}
            </Checkbox>
          </Space>
          <Divider />
          <Space>
            <Button
              type="primary"
              onClick={() => onSubmit({ consent_changes: consent })}
              disabled={!consent}
            >
              {getTranslatedString('tenantPortal.application.submitApplication')}
            </Button>
            <Button type="default" onClick={onClickSave}>
              {getTranslatedString('tenantPortal.application.saveApplication')}
            </Button>
            <Button type="default" onClick={previousStep}>
              {getTranslatedString('back')}
            </Button>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default ApplicationSubmission;
